<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <AromaEmpressCheckout :combos="combos" :key="$route.fullPath"/>
  </b-container>
</template>
<style>

</style>

<script>
import AromaEmpressCheckout from "@/components/checkout/aromaempress/AromaEmpressCheckout.vue";

export default {
  title: 'Dropsmart Aroma Express Checkout',
  name: "AromaEmpress",
  props: ["combos"],
  components: {
    AromaEmpressCheckout
  },
};
</script>
